package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_07_05_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-07-05")
@Composable
public fun Log_2024_07_05(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Seven Shard Locations",
        ogTitle = "Seven Shard Locations",
        date = LocalDate(2_024, 7, 5),
        ogDescription = "The Peers return the first shard to the heroes, who now have a summary of the seven remaining shard locations.",
        ogImage = "images/RemainingShards_small.webp",
        ogImageWidth = 1_080,
        ogImageHeight = 805,
        ogImageAlt = "A hand-drawn map of Veldekar with pink numbers 1-7 identifying the remaining shards of the Shield of Concar as scried by the Heroes.",
    ) {
        SessionDayHeader(dayId = "newgrowth-53", dateString = "Newgrowth 53")
        Log_2024_07_05_Day_1()
        SessionMediaItem(
            image = "images/RemainingShards_small.webp",
            linkImage = "images/RemainingShards.webp",
            description = "A hand-drawn map of Veldekar with pink numbers 1-7 identifying the remaining shards of the Shield of Concar as scried by the Heroes.",
            width = 1_080,
            height = 805,
        )
    }
}
